import { render } from "./trainingAddParticipantsModal.vue?vue&type=template&id=2a5babe0&ts=true"
import script from "./trainingAddParticipantsModal.vue?vue&type=script&lang=ts"
export * from "./trainingAddParticipantsModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__